export const getLatePaymentInterestApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/late-payment-interest/${queryString ? `?${queryString}` : ""}`;
};

export const addLatePaymentInterestApi = (params) => {
    return `lease/${params?.leaseSlug}/late-payment-interest/`;
}

export const updateLatePaymentInterestApi = (params) => {
    return `lease/${params?.leaseSlug}/late-payment-interest/${params?.slug}/`;
};

export const deleteLatePaymentInterestApi = (params) => {
    return `lease/${params?.leaseSlug}/late-payment-interest/`;
};

export const exportLatePaymentInterestApi = (leaseId) => {
    return `lease/${leaseId}/export/late-payment-interest/`;
};

export const latePaymentInterestfileUploadPostApi = (late_payment_interest_slug) => {
    return `/get-pre-signed-url/late_payment_interest/${late_payment_interest_slug}`;
};

export const latePaymentInterestAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/late_payment_interest/${attachments_slug}`
}